import { componentClasses } from "../../../core/components/notification/notification";
import { prefix } from "../../../core/js/utilities";

const Template = (args) => {
    const timeStamp = args.timeStamp
        ? `<div class="${prefix}notification__time-stamp">
                ${args.timeStamp}
            </div>`
        : "";

    const primaryAction =
        args.primaryAction && args.primaryActionText !== ""
            ? `
    <button type="button" class="${componentClasses.button.base} ${componentClasses.button.primary}">
        ${args.primaryActionText}
    </button>`
            : "";

    const secondaryAction =
        args.secondaryAction && args.secondaryActionText !== ""
            ? `<button type="button" class="${componentClasses.button.base} ${componentClasses.button.secondary}">
        ${args.secondaryActionText}
            </button>`
            : "";

    const titleIcon =
        args.titleIconType === "svg"
            ? `<span class="${componentClasses.icon.base}"><svg aria-hidden="true"><use xlink:href="#${args.titleIcon}"></use></svg></span>`
            : `<span class="${componentClasses.icon.base}"><i class="dds__icon ${args.titleIcon}" aria-hidden="true"></i></span>`;

    const closeButton = args.closeIcon
        ? ` <button type="button" aria-label="Close dialog"
            class="${componentClasses.icon.close}" 
            alt="close-icon"
        >
        </button>`
        : "";

    return `
        <div 
            class="${componentClasses.base}" 
            role="alert" 
            aria-live="${args.politeness || "polite"}" 
            aria-atomic="true"
        >
            ${args.titleIcon ? titleIcon : ""}
            <div class="${componentClasses.body}">
                <div class="${componentClasses.header}">
                    <span class="${componentClasses.headerTitle}">
                        ${args.title}
                    </span>
                    ${closeButton}
                </div>
                <p class="${componentClasses.message}">
                    ${args.messageBody}
                </p>
                ${timeStamp}
                <div class="${componentClasses.footer}">
                    ${secondaryAction}${primaryAction}
                </div>
            </div>
        </div>    
    `;
};

export default Template;
